import { render, staticRenderFns } from "./AnalysisToolsPagerSelect.vue?vue&type=template&id=b3c43254&scoped=true"
import script from "./AnalysisToolsPagerSelect.vue?vue&type=script&lang=ts"
export * from "./AnalysisToolsPagerSelect.vue?vue&type=script&lang=ts"
import style0 from "./AnalysisToolsPagerSelect.vue?vue&type=style&index=0&id=b3c43254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c43254",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/analysis-tools/analysis-tools-pager-select.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fanalysis-tools%2FAnalysisToolsPagerSelect.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports